// extracted by mini-css-extract-plugin
export var body = "PromotionFeatured-module--body--8a6e1";
export var image = "PromotionFeatured-module--image--fd603";
export var inner = "PromotionFeatured-module--inner--bce15";
export var promotion = "PromotionFeatured-module--promotion--05ad4";
export var title = "PromotionFeatured-module--title--d9437";